/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PaintbrushThickIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABg0lEQVR4nOWTvUoDQRDHrWxErEQiiBbWPkAKu4CGzMepm5kYlYC+hiad8SHsVXwPBcFCsPADrYyt2KpEjtzGy2Vzt4Y04sA2s3f/38x/ZsfG/n0YY8aR5QhIWsDygqzNMDcyY5C1iaztxGmODAAkrT4A6au3AFGliCSn4SmxrPZUjzjpqL4dWuUljqx1h0D9B1BedgJID31ab7h+7gjIMVFlD1kfkpV7DTlNHPv8lnsiyRcKWxNetlhxIPnyAQDJrpdwovKPElXWB8ygzy5f8ZoVB9ayzaMHJD74FIA+RhXVknfIcpAFCdc5HcD6Hn4YBNWc6x4zIMB6kgpAlvNo1S6NMVO/hUAmAHUWWJ8tBMAsAssVkl70dEqy7wIkX7kziGTBQsJhR7DrFWOm4zAHJHvINoprm/NxCJHkgeXGwqJuN4D0M1qKhrf4IAh2PL4F0BkMxHRzw4jHIcj61H0boEslku2RiNsgkjn7Pob2PCuCoJpD0jMgfQPSO8TyzsjE/0R8A1PLgvOppV1eAAAAAElFTkSuQmCC)
 */
export const PaintbrushThickIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M15.35 7.24C15.9 6.67 16 5.8 16 5a3 3 0 1 1 3 3c-.8 0-1.67.09-2.24.65a1.5 1.5 0 0 0 0 2.11l1.12 1.12a3 3 0 0 1 0 4.24l-5 5a3 3 0 0 1-4.25 0l-5.76-5.75a3 3 0 0 1 0-4.24l4.04-4.04.97-.97a3 3 0 0 1 4.24 0l1.12 1.12c.58.58 1.52.58 2.1 0ZM6.9 9.9 4.3 12.54a1 1 0 0 0 0 1.42l2.17 2.17.83-.84a1 1 0 0 1 1.42 1.42l-.84.83.59.59 1.83-1.84a1 1 0 0 1 1.42 1.42l-1.84 1.83.17.17a1 1 0 0 0 1.42 0l2.63-2.62L6.9 9.9Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
